import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { DeviceSetting } from '../../../models';

declare var plugin: any;

@Component({
  selector: 'app-cameras',
  templateUrl: './cameras.component.html',
  styleUrls: ['./cameras.component.css']
})
export class CamerasComponent implements OnInit, OnDestroy {

  devices: DeviceSetting[];

  constructor() { }

  ngOnInit() {
    this.devices = new Array<DeviceSetting>();
    for (let i = 0; i < 4; i++) {
      this.devices.push(new DeviceSetting());
    }
    this.devices[0].name = "Wjazd B4";
    this.devices[0].deviceIP = "10.100.40.221";
    this.devices[1].name = "Wjazd B5";
    this.devices[1].deviceIP = "10.100.40.222";
    this.devices[2].name = "Wyjazd B4";
    this.devices[2].deviceIP = "10.100.40.241";
    this.devices[3].name = "Wyjazd B5";
    this.devices[3].deviceIP = "10.100.40.242";
  }

  ngOnDestroy() {
    for (let i = 1; i < 4; i++) {
      let idName = "videoPlugin" + i;
      plugin.stopPlugin(idName, 1);
    }
  }
}
